import React, { useMemo } from "react";
import { makeAutoObservable } from "mobx";
import { ZAttribute } from "src/types/ZAttribute";
import { makeDictionary } from "src/common/makeDictionary";
import { loadObjectAttrinbutesAll } from "src/pages/ManagementPage/objectsApi";
import { onError } from "src/common/onError";
import { getTypesMap } from "src/references/getTypesMap";
import { Form } from "antd";
import { AttrTypeName } from "src/types/AttrType";
import { observer } from "mobx-react-lite";
import { edAttrField } from "src/pages/ManagementPage/Obj2Tab/EdAttribute";
import { ZUid } from "src/types/zUid";
import { gbName, makeFormName } from "./names";
import { ArticleTemplateInput } from "./ArticleTemplateInput";
import { ArticleAttrMetaForm } from "./ArticleAttrMetaForm";

const createStore = (objectId: ZUid) => {
  const store = makeAutoObservable({
    attsDict: {} as Record<ZUid, ZAttribute>,
    setAttsDict(dict: Record<ZUid, ZAttribute>) {
      this.attsDict = dict;
    },
    attrTypesMap: {} as Record<number, string>,
    setAttrTypesMap(dict: Record<number, string>) {
      this.attrTypesMap = dict;
    },
    init() {
      loadObjectAttrinbutesAll(objectId)
        .then((d) => this.setAttsDict(makeDictionary(d, ({ id }) => id)))
        .catch(onError);
      getTypesMap()
        .then((data) => this.setAttrTypesMap(data))
        .catch(onError);
    },
  });
  store.init();
  return store;
};

type PropsAttrArticleTemplateForm = {
  objectId: ZUid;
  articleSettingsDisabled?: boolean;
};
export const AttrArticleTemplateForm: React.FC<PropsAttrArticleTemplateForm> =
  observer(({ objectId, articleSettingsDisabled }) => {
    const store = useMemo(() => createStore(objectId), []);
    const name = edAttrField.articleNumberInfo;
    const attributeIds = Form.useWatch<{ attributeId: ZUid }[] | undefined>(
      makeFormName(name, "attributes"),
    );
    const attsGroup = Form.useWatch<ZUid[] | undefined>(
      gbName(name, "attrIds"),
    );
    const selectedAtts = Array.from(
      new Map(
        [
          ...(attsGroup || []),
          ...(attributeIds || []).map(({ attributeId }) => attributeId),
        ].map((attrId) => [attrId, store.attsDict[attrId]]),
      ).values(),
    ).filter(Boolean) as ZAttribute[];
    const refLikeAtts = selectedAtts.filter(
      (attr) => store.attrTypesMap[attr.valueType] === AttrTypeName.object,
    );

    return (
      <>
        <ArticleTemplateInput
          store={store}
          objectId={objectId}
          baseName={name}
          disabled={articleSettingsDisabled}
        />
        <ArticleAttrMetaForm
          store={store}
          attributes={refLikeAtts}
          baseName={name}
          disabled={articleSettingsDisabled}
        />
      </>
    );
  });
